import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSidebarData } from '../../../hooks/sidebarData';
import { useQuery } from '@tanstack/react-query';
import axios from '../../../api/axios';
import { destroySession } from '../../../helpers/Session';

const NDOTDetails = () => {
    const navigate = useNavigate();
    const { sidebarData } = useSidebarData();

    const timeoutRef = useRef(null);

    const accesstoken = sessionStorage.getItem('accesstoken');

    const { data: ndot, isLoading, error } = useQuery({
        queryKey: ['userNDOTRequestDetails', { sidebarData }],
        queryFn: async () => {
            const res = await axios.get(`ndot/details/${sidebarData.data?.uname}?id=${sidebarData.data?.ndotrequestid}`, {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        },
        enabled: !!sidebarData.data?.uname && !!sidebarData.data?.ndotrequestid && !!accesstoken,
        retry: 1
    });

    useEffect(() => {
        if (error) {
            if (error.response.data?.status === 'inactive') {
                destroySession();
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
            }
        }
    }, [error]);

    return (
        <div className={`ndot-request ${isLoading ? 'loading' : ''}`}>
            <table>
                <tbody>
                    <tr>
                        <th>Name</th>
                        <td>
                            <span>{ndot?.name}</span>
                        </td>
                    </tr>
                    <tr>
                        <th>Request Type</th>
                        <td>
                            <span>{ndot?.requesttype}</span>
                        </td>
                    </tr>
                    <tr>
                        <th>Start Date</th>
                        <td>
                            <span>{ndot?.startdate}</span>
                        </td>
                    </tr>
                    <tr>
                        <th>End Date</th>
                        <td>
                            <span>{ndot?.enddate}</span>
                        </td>
                    </tr>
                    <tr>
                        <th>Total Hours</th>
                        <td>
                            <span>{ndot?.totalhours}</span>
                        </td>
                    </tr>
                    <tr>
                        <th colSpan={2}>Justification</th>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            <span>{ndot?.justification}</span>
                        </td>
                    </tr>
                    {ndot?.attachment.length > 0 && (
                        <>
                            <tr>
                                <th colSpan={2}>Attachments</th>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    {ndot?.attachment.map(item => (
                                            <span>
                                                <a href={item.url} target='_blank' title={item.name} className='icon'>
                                                    <i className={`fa ${item.type === 'pdf' ? 'fa-file-pdf' : (item.type === 'doc' || item.type === 'docx' ? 'fa-file-word' : 'fa-file-image')}`}></i>
                                                </a>
                                            </span>
                                        ))
                                    }
                                </td>
                            </tr>
                        </>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default NDOTDetails;